<template>
  <div id="uploader_box">
    <el-upload
      :action="uploadUrl"
      list-type="picture-card"
      :class="{ disabled: uploadDisabled }"
      :auto-upload="false"
      :limit="1"
      ref="uploader"
      :on-change="handleChange"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :file-list="fileList"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <!-- 预览图片 -->
    <el-dialog :visible.sync="PreviewdialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { baseURL } from "@/request/request";
import { DeleteUpload } from "@/request/api";

export default {
  data() {
    return {
      uploadUrl: baseURL + "/common/upload",
      PreviewdialogVisible: false,
      dialogImageUrl: "",
    };
  },
  props: {
    fileList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    uploadDisabled: function () {
      return this.fileList.length != 0; // this.uploadfilename != "";
    },
  },
  methods: {
    // 添加活动展示照片
    handleChange(file, fileList) {
      console.log("handleChange===>", fileList);
      this.$emit("ResetFilelist", fileList);
      // const isJPG = file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      // const isLt5M = file.size / 1024 / 1024 < 5;
      // if (!isJPG) {
      //   this.$message.error("上传图片只能是 JPG 、png 格式!");
      //   return false;
      // }
      // if (!isLt5M) {
      //   this.$message.error("上传图片大小不能超过 5MB!");
      //   return false;
      // }
      // this.uploadfilename = fileList[0].name;
      // this.$emit("Selected", this.uploadfilename);
    },

    upload() {
      console.log("upload....", this.fileList);
      this.$refs.uploader.submit();
    },
    // 删除活动展示照片
    handleRemove(file) {
      console.log("handleRemove==>", file);
      var IsLocal = file.name === undefined ? false : true;
      console.log("IsLocal==>", file.name, IsLocal);
      const param = {};
      var url = file.url;

      param.filename = IsLocal
        ? file.name
        : url.substring(url.lastIndexOf("/") + 1, url.length);

      console.log("param====>", param);
      if (!IsLocal) {
        DeleteUpload(param).then((res) => {
          console.log(res);
        });
      }
      this.$emit("ResetFilelist", []);
       
    },
    // 活动展示照片预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      console.log("Preview--->", this.dialogImageUrl);
      this.PreviewdialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.disabled {
  .el-upload--picture-card {
    display: none;
  }
}
</style>